// lib
import React from 'react'
import PropTypes from 'prop-types'

// components
import ViewModes from '@aytm/app/stats/page/question-views/oe/components/Controls/ViewModes'
import VerbatimControls from '@aytm/app/stats/page/question-views/oe/components/Controls/Verbatim'
import TagsControls from '@aytm/app/stats/page/question-views/oe/components/Controls/Tags'
import WordcloudControls from '@aytm/app/stats/page/question-views/oe/components/Controls/Wordcloud'
import ExportControls from '@aytm/app/stats/page/question-views/oe/components/Controls/Export'

const ControlsComponents = ({
  model,
  data,
  features,
  collapsed,
  disabled,
  isVerbatimType,
  isSurveyGuest,
  onViewModeChange,
  onConfigChange,
  onPresetChange,
  onApplyToAll,
  onExport,
  onToggle
}) => {
  const { chartMode, viewMode } = model

  return disabled ? null : (
    <>
      {<ViewModes model={model} data={data} onViewModeChange={onViewModeChange} />}
      {'verbatim' == viewMode ? (
        <VerbatimControls
          model={model}
          data={data}
          features={features}
          isSurveyGuest={isSurveyGuest}
          onConfigChange={onConfigChange}
          onExport={onExport}
        />
      ) : null}
      {'tags' == viewMode ? <TagsControls model={model} onConfigChange={onConfigChange} /> : null}
      {'wordcloud' == viewMode && !['map', 'none'].includes(chartMode) ? (
        <WordcloudControls
          model={model}
          data={data}
          features={features}
          collapsed={collapsed}
          isVerbatimType={isVerbatimType}
          isSurveyGuest={isSurveyGuest}
          onPresetChange={onPresetChange}
          onApplyToAll={onApplyToAll}
          onExport={onExport}
          onToggle={onToggle}
        />
      ) : isVerbatimType ? (
        <ExportControls model={model} features={features} isSurveyGuest={isSurveyGuest} onExport={onExport} />
      ) : null}
    </>
  )
}

ControlsComponents.propTypes = {
  model: PropTypes.object,
  data: PropTypes.object,
  features: PropTypes.object,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  isVerbatimType: PropTypes.bool,
  isSurveyGuest: PropTypes.bool,
  onViewModeChange: PropTypes.func,
  onConfigChange: PropTypes.func,
  onPresetChange: PropTypes.func,
  onApplyToAll: PropTypes.func,
  onExport: PropTypes.func,
  onToggle: PropTypes.func
}

ControlsComponents.displayName = 'ControlsComponents'

export default ControlsComponents
